const template = `
<div class="grid">
	<div class="rows">

		<div class="row" data-sticky-template="grid-row">
			<div class="cell first colored-background colored-text" data-sticky-template="grid-first-cell">
				<div class="time"></div>
				<div class="title"></div>
				<div class="info"></div>
				<span class="sprite more more-white"></span>
			</div>
			<div class="cell" data-sticky-template="grid-cell">

				<div class="content">
					<div class="number colored-background colored-text colored-outline-border"></div>
					<div class="left-info align y">
						<div>
							<div class="info-1"></div>
							<div class="info-2"></div>
						</div>
					</div>
					<div class="right-info align y">
						<div class="shoe"></div>
						<div class="wagon"></div>
					</div>
					<div class="horse-name"></div>
					<div class="jockey-trainer-name"></div>
					<div class="bottom-info"></div>
					<div class="bottom-blue"></div>
					<div class="scratched"></div>
					<div class="checkbox"><input type="checkbox" name="checkbox"><span></span></div>
					<svg class="comment-indicator" viewBox="0 0 100 100"><path d="M0 100L100 0V100Z" /></svg>
				</div>

			</div>

			<div class="copy-cell" data-sticky-template="grid-copy-cell">
				<div class="copy-button"><span class="button-caption"></span><span class="arrow">&darr;</span></div>
			</div>
		</div>

	</div>

	<div class="header">
		<div class="cell first" data-sticky-template="grid-header-first-cell"></div>
		<div class="cell" data-sticky-template="grid-header-cell"></div>
	</div>

	<div class="overlay">
		<div class="top"></div>
		<div class="middle">
			<div class="left"></div>
			<div class="right"></div>
		</div>
		<div class="bottom"></div>
	</div>

	<div class="cell-buttons">

		<div class="button" data-sticky-template="grid-cell-button">
			<div class="wrapper">
				<div class="align y x"><div><div class="base"></div></div></div>
				<div class="align y x"><div class="content"></div></div>
			</div>
		</div>

	</div>

</div>
`;

export default template;
